// CallbackPage.tsx
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { updateUserField } from '../../redux/userSlice';

const CallbackPage = () => {
  const { error: auth0Error } = useAuth0();
  const dispatch = useDispatch();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('Starting authentication callback...');
    // If there's a referral code in sessionStorage, move into Redux
    try {
      const referralCode = sessionStorage.getItem('referral_code');
      if (referralCode) {
        dispatch(updateUserField({ key: 'referralCode', value: referralCode }));
        // Optionally remove so it doesn't apply again:
        sessionStorage.removeItem('referral_code');
      }
      const counsellorCode = sessionStorage.getItem('counsellor_code');
      if (counsellorCode) {
        dispatch(updateUserField({ key: 'counsellorCode', value: counsellorCode }));
        // Optionally remove so it doesn't apply again:
        sessionStorage.removeItem('counsellor_code');
      }
    } catch (e) {
      console.warn('Could not read codes from sessionStorage', e);
    }

    if (auth0Error) {
      console.error('Authentication error details:', auth0Error);
      setError(auth0Error.message || 'Authentication failed. Please try again.');
      localStorage.removeItem('auth0.is.authenticated');
      sessionStorage.removeItem('auth_redirect_in_progress');
      sessionStorage.removeItem('is_logging_out');
    }
  }, [auth0Error, dispatch]); // Removed logout from dependencies to avoid loop if it's not needed immediately

  if (error) { console.error("Error ", error) }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md w-full">
        {error ? (
          <>
            <div className="text-red-500 text-5xl mb-4">⚠️</div>
            <p className="text-xl font-semibold text-gray-800 mb-2">Authentication Failed</p>
            <p className="text-sm text-gray-600 mb-6">{error}</p>
            <button
              onClick={() => window.location.href = '/login'}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full transition duration-300"
            >
              Try Again
            </button>
          </>
        ) : (
          <>
            <p className="text-xl font-semibold">Signing you in...</p>
            <p className="text-sm text-gray-500 mt-2">Please wait while we complete the authentication process</p>
          </>
        )}
      </div>
    </div>
  );
};

export default CallbackPage;
